<template>
    <button :data-type="type" :class="{'active': active}" :disabled="disabled">
        <slot/>
    </button>
</template>

<script>
export default {
    name: 'Button',
    props: ['type', 'active', 'disabled'],
}
</script>

<style lang="scss" scoped>
@import '../../../assets/scss/variables.scss';
button {
    &:disabled {
        filter: grayscale(100%) opacity(0.5);
    }
    &[data-type="tab-button"] {
        height: 55px;
        text-align: center;
        font-size: $p4;
        font-weight: $weight_bold;
        color: $c3;
        background: $c11;
        border-top: 4px solid transparent;
        padding-left: 24px;
        padding-right: 24px;
        &.active {
            pointer-events: none;
            background: $c14;
            border-top: 4px solid $c1;
            color: $c6;
        }
    }
    &[data-type="accept"], &[data-type="decline"] { 
        width: 65px;
        height: 25px;
        font-size: $p5;
        font-weight: $weight_bold;
        border-radius: 5px;
        transition: all 0.2s ease;
        background: $c14;
        margin: 0 !important;
        &.height-auto {
            height: auto
        }
    }
    &[data-type="decline"] {
        color: $c3;
        border: 1px solid $c3;
        &:hover {
            background: $c3;
            color: $c14;
        }
    }
    &[data-type="accept"] {
        color: $c2;
        border: 1px solid $c2;
        margin-left: 8px !important;
        &:hover {
            background: $c2;
            color: $c14;
        }
    }
    &[data-type="schedule-update"]{
        color: $c1;
        border: 1px solid $c1;
        font-size: $p5;
        font-weight: $weight_bold;
        border-radius: 5px;
        transition: all 0.2s ease;
        &:hover {
            background: $c1;
            color: $c14;
        }
    }
    &[data-type="rowCount"] {
        color: $c1;
        font-size: $p5;
    }
    &[data-type="cpInfo"] {
        border: 1px solid $c1;
        border-radius: 5px;
        background: $c14;
        color: $c1;
        font-size: $p5;
        text-align: center;
        transition: all 0.2s ease;

        &:hover {
            background: $c1;
            color: $c14;
        }
    }
    &[data-type="viewUpdate"] {
        color: $c2;
        font-size: $p5;
    }
    &[data-type="emptyState"] {
        padding-left: 24px;
        padding-right: 24px;
        padding-top: 10px;
        padding-bottom: 10px;
        background: $c1;
        border-radius: 5px;
        color: $c14;
        font-size: $p4;
        font-weight: $weight_bold;
        transition: all 0.2s ease;
        &:hover {
            box-shadow: 0px 4px 8px rgba(114, 124, 245, 0.45);
        }
    }
    &[data-type="linkButton"] {
        color: $c1;
        font-size: $p5;
        font-weight: $weight_bold;
    }
    &[data-type="clear"] {
        width: 72px;
        height: 36px;
        font-size: $p7;
        color: $c27;
        text-transform: capitalize;
        background: $c11;
        border-radius: 5px;
        transition: all 0.3s ease;

        &.active {
            background: $c1;
            color: $c14;

            img {
                filter: brightness(0) invert(1);
            }
        }
    }
    &[data-type="next"] {
        margin-left: 8px;
    }
    &[data-type="prev"] {
        margin-left: 16px;
    }
    &[data-type="prev"], &[data-type="next"]  {
        width: 30px;
        height: 30px;
        border-radius: 50%;
        background: $c30;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    &[data-type="editInfo"] {
        width: 100%;
        height: 36px;
        background: $c1;
        transition: all 0.2s ease;
        color: $c14;
        font-size: $p3;
        font-weight: $weight_bold;
        border-radius: 5px;

        &:hover {
            box-shadow: 0px 4px 8px rgba(114, 124, 245, 0.45);
        }

    }
    &[data-type="chat"] {
        width: 28px;
    }
}
</style>